import React from 'react';
import * as S from './EmptyState.styled';
export const EmptyState = ({ title, subtitle, children }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.InnerContainer, null,
            React.createElement(S.TopContainer, null,
                React.createElement(S.Title, null, title),
                React.createElement(S.Subtitle, null, subtitle)),
            children)));
};
export const Root = EmptyState;
export const Recommendations = S.Recommendations;
export const Suggestion = S.Suggestion;
